import { useState } from "react";

import ModalTemplate from "../../../common/modal/modalTemplate";
import BtnSpinner from "../../../common/btnSpinner";
import { formatHHMM } from "../../../utils";
import { removeCurrentJob } from "../../../storage";
import { theme } from "../../../theme";

import { rescheduleJobAccept } from "../service";
import { showNotification } from "../../../common/notifications/notifications";
import { customerCancelJobByRescheduleJob } from "../../currentJob/service";
import useCustomNavigate from "../../../common/hooks/useCustomNavigate";
import BookAgain from "../../components/bookAgain/BookAgain";

import "./RescheduleJobAlert.css";

const RescheduleJobAlert = ({
    show,
    rescheduleJob_data,
    handleClose
}) => {
    const { navigateToCustom } = useCustomNavigate();
    const [acceptLoading, setAcceptLoading] = useState(false);
    const [showBookAgain, setShowBookAgain] = useState(false);

    const rescheduleTime = `${formatHHMM(rescheduleJob_data?.reschedule_job_start_timestamp)} - ${formatHHMM(rescheduleJob_data?.reschedule_job_end_timestamp)}`;

    const acceptNewTime = async () => {
        try {
            setAcceptLoading(true);
            await rescheduleJobAccept(rescheduleJob_data?.reschedule_job_id);
        } finally {
            setAcceptLoading(false);
            handleClose();
        }
    };

    const openBookAgain = () => setShowBookAgain(true);
    
    const closeBookAgain = () => {
        setShowBookAgain(false);
        removeCurrentJob();
        navigateToCustom("/home");
    }

    const cancelJob = async () => {
        showNotification({
            notificationType: "CANCEL_JOB",
            preConfirm: async () => await customerCancelJobByRescheduleJob(rescheduleJob_data?.job_id, rescheduleJob_data?.reschedule_job_id),
            isConfirmed: async (result) => {
                if (!result.isConfirmed || result.value?.status !== "Success") return;

                // removeCurrentJob();
                // navigateToCustom("/home");

                handleClose();
                openBookAgain();
            },
        });
    };

    return (
        <>
            <ModalTemplate
                show={show}
                centered
                closeFun={null}
                body={
                    <div className="reschedule-alert">
                        {/* Title */}
                        <h5 className="reschedule-alert-title">
                            Engineer has requested
                            <br />
                            new arrival time
                        </h5>

                        {/* Time */}
                        <div className="reschedule-alert-time">
                            {rescheduleTime}
                        </div>

                        {/* Description */}
                        <p className="test-lg">
                            If this time doesn’t work, you can cancel with a full refund.
                        </p>

                        <button type="button" className={`btn btn-${theme.main} btn-sm w-100 mt-3 mb-2`} onClick={acceptNewTime} disabled={acceptLoading}>
                            {acceptLoading ? <BtnSpinner /> : "Accept new time"}
                        </button>

                        <button type="button" className={`btn btn-link btn-sm w-100 text-secondary mb-0`} onClick={cancelJob}>
                            Cancel job
                        </button>
                    </div>
                }
            />

            <BookAgain show={showBookAgain} handelClose={closeBookAgain} reschedule_job_id={rescheduleJob_data?.reschedule_job_id}/>
        </>
    );
};

export default RescheduleJobAlert;